// utils/dateUtils.js

/**
 * تبدیل تاریخ میلادی به شمسی
 */
export const toPersianDate = (gregorianDate) => {
  if (!gregorianDate) return "";

  const date = new Date(gregorianDate);
  return date.toLocaleDateString("fa-IR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

/**
 * تبدیل تاریخ میلادی به شمسی با ساعت
 */
export const toPersianDateTime = (gregorianDate) => {
  if (!gregorianDate) return "";

  const date = new Date(gregorianDate);
  return date.toLocaleDateString("fa-IR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/**
 * فرمت کردن شماره تلفن
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return "";

  // حذف کاراکترهای غیرعددی
  let cleaned = phone.toString().replace(/\D/g, "");

  // اگر با 98 شروع می‌شه، فرمتش کن
  if (cleaned.startsWith("98")) {
    if (cleaned.length === 12) {
      return cleaned.replace(/(98)(\d{3})(\d{3})(\d{4})/, "$1 $2 $3 $4");
    }
  }

  return phone;
};

/**
 * نرمال‌سازی شماره تلفن (تبدیل به فرمت 98)
 */
export const normalizePhoneNumber = (phone) => {
  if (!phone) return "";

  let cleaned = phone.toString().replace(/\D/g, "");

  if (cleaned.startsWith("0")) {
    cleaned = cleaned.substring(1);
  }

  if (!cleaned.startsWith("98")) {
    cleaned = "98" + cleaned;
  }

  return cleaned;
};
